import { Star } from "lucide-react";

export const StarRating = ({ rating = 5, className = "" }) => (
  <div className={`flex gap-0.5 ${className}`} aria-label={`${rating} out of 5`}>
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={15} className={i < rating ? "fill-[#9E8773] text-[#9E8773]" : "text-[#D8D3C9]"} />
    ))}
  </div>
);
